
import React from 'react';
import { Link } from 'office-ui-fabric-react/lib/Link';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';

import { utils } from '../../../core';

import getStylesFromCssString from './getStylesFromCssString';
import getStylesFromDefinition from './getStylesFromDefinition';

const AttributeExecuteCommand = ({appConfig, definition, infoDefinition, values, onCloseDialog}) => {

    const classNames = mergeStyleSets({
        root: {
            paddingTop: 4,
            paddingBottom: 4,
            ...getStylesFromDefinition(appConfig, 'info.styles.attrContainer'),
            ...getStylesFromDefinition(infoDefinition, 'styles.attrContainer'),
            ...getStylesFromCssString(definition.containerStyles)
        }
    });

    const handleClick = () => {
        let commandString = processTemplateValues(definition.commandTemplate, values);
        utils.loadJsonFromText(commandString, (err, result) => {
            if (!err) {
                MultiSceneForApp.executeCommand(result);
                if (onCloseDialog && definition.closeOnExecute) {
                    onCloseDialog();
                }
            }
        });
    }

    return (
        <Stack className={classNames.root}>
            <Link onClick={handleClick}>{definition.title}</Link>
        </Stack>
    );
}

export default AttributeExecuteCommand;
